export default __webpack_public_path__ + "images/92a8d18915b3e6ec9868699bdcff12b8-plus.svg";